import { useEffect } from 'react';
import { APIError } from '@tajawal/web-core-sdk-v2/lib/utils/sentry.utils';
import type { Store } from '@/stores';

export default function useFetchMarketingBanners(store: Store, isRoundTrip: boolean) {
  const pageStore = isRoundTrip ? store.appStore.stepByStepSearchPage : store.appStore.completeSearchPage;
  useEffect(() => {
    function handleError(error) {
      // @ts-ignore
      APIError({ error, tag: 'MARKETING_BANNERS_FETCH_ERROR' });
    }

    /**
     * Campaigns fetch
     */
    pageStore.marketingBanners.fetch({ errorHandler: handleError });
  }, [pageStore]);
}
